module.exports = {
	"name": "Camunda",
	"uri": "http://camunda.org/schema/1.0/dmn",
	"prefix": "camunda",
	"xml": {
		"tagAlias": "lowerCase"
	},
	"types": [
		{
			"name": "InputVariable",
			"extends": [
				"dmn:InputClause"
			],
			"properties": [
				{
					"name": "inputVariable",
					"isAttr": true,
					"type": "String"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./~/dmn-moddle/resources/dmn/camunda/camunda.json
// module id = 1140
// module chunks = 1